import "./../styles/main.scss";
import SlimSelect from 'slim-select';
import $ from "jquery";
import Siema from "siema";
import Timer from "./helpers/Timer";
import L from "leaflet";
import "leaflet-providers";
require("jquery.scrollto");
require('simplelightbox');
import inView from "in-view";
require("./helpers/ihavecookie");
var alreadyInit = false;
function showMap() {
    if ($("#map").length && alreadyInit == false) {
        alreadyInit = true;
        var map_1 = L.map('map');
        var lat = 50.838589;
        var lng = 4.417500;
        map_1.setView([lat, lng], 12);
        map_1.scrollWheelZoom.disable();
        L.tileLayer.provider("CartoDB.Positron").addTo(map_1);
        map_1.touchZoom.disable();
        var icon_1 = new L.Icon({
            iconUrl: '/app/themes/spruce/static/gfx/pointer.png',
            iconSize: [39 / 2, 59 / 2],
            iconAnchor: [18 / 2, 59 / 2],
            popupAnchor: [1, -59 / 2],
            shadowSize: [0, 0]
        });
        $('#properties-list .property').each(function (i, e) {
            var $this = e;
            L
                .marker([parseFloat($(e).data("lat")), parseFloat($(e).data("lng"))], { icon: icon_1 })
                .addTo(map_1);
        });
    }
}
$(document).ready(function () {
    $.scrollTo(0);
    $(".download-plan-wrapper").on("click", "a", function (e) {
        e.preventDefault();
        $('.iframe-plan').fadeIn(500);
    });
    $('.iframe-plan').on("click", function (e) {
        $(e.currentTarget).fadeOut(500);
    });
    if ($("#gallery").length) {
        $('#gallery a').simpleLightbox({ showCounter: false });
    }
    $("body").on("click", ".view-switcher", function (e) {
        e.preventDefault();
        $('.view-switcher').removeClass("selected");
        $(e.currentTarget).addClass("selected");
        var classe = $(e.currentTarget).attr("href").replace("#", "");
        $('#properties-list').removeClass().addClass(classe);
        if (classe == "map")
            showMap();
    });
    if ($("#tplform").length) {
        $("#tplform .first_row").find("input[type='hidden'].property_reference").val($("#tplform").data("property"));
        $("#tplform .first_row").find("input[type='hidden'].property_type").val($("#tplform").data("type"));
        $('.show-contact').on("click", function (e) {
            e.preventDefault();
            // contactFormModalInstance.show();
            $('#tplform').fadeIn(300);
        });
        $('#tplform').on("click", ".close a", function (e) {
            e.preventDefault();
            $('#tplform').fadeOut(300);
        });
    }
    if ($(".slim-selector").length) {
        $('.slim-selector').each(function (i, e) {
            var $this = $(e);
            var options = {
                select: ('#' + $this.attr("id")),
                placeholder: $this.data("placeholder"),
                searchText: $this.data("search-text"),
                searchPlaceholder: $this.data("search-placeholder")
            };
            if ($this.hasClass("is-ajax")) {
                var url_1 = $this.data("uri");
                options["searchingText"] = $this.data("searching");
                options["ajax"] = function (search, callback) {
                    if (search.length < 3) {
                        callback($this.data("min"));
                        return;
                    }
                    fetch(url_1)
                        .then(function (response) {
                        return response.json();
                    })
                        .then(function (json) {
                        var data = json;
                        callback(data);
                    })["catch"](function (error) {
                        callback(false);
                    });
                };
            }
            new SlimSelect(options);
        });
    }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    inView.offset(100);
    inView('*[data-appear]')
        .on('enter', function (el) {
        if ($(el).attr('data-appearlater') === void 0)
            $(el).addClass('animated ' + $(el).attr('data-appear'));
    });
    $('*[data-appearlater]').each(function (i, e) {
        var $this = $(e);
        setTimeout(function () {
            $this.addClass('animated ' + $this.attr('data-appear'));
        }, 150 * i);
    });
    $('.slider').each(function (i, e) {
        var sliderNode = $(e);
        var sliderTimer = new Timer(function () {
            slider.next();
        }, 5000);
        var slider = new Siema({
            selector: sliderNode.find('.siema').get(0),
            loop: true,
            duration: 400,
            onInit: function () {
                sliderNode.find('.navigation').children(":nth-child(1)").addClass("active");
                sliderTimer.start();
            },
            onChange: function () {
                var navigation = sliderNode.find(".navigation");
                navigation.find(".active").removeClass("active");
                navigation.children(":nth-child(" + (this.currentSlide + 1) + ")").addClass("active");
                sliderTimer.reset(5000);
            }
        });
        sliderNode.find(".navigation").on("click", "span", function (e) {
            slider.goTo($(e.currentTarget).index());
        });
        sliderNode.hover(function () {
            sliderTimer.stop();
        }, function () {
            sliderTimer.start();
        });
        sliderNode.on("click", ".control a", function (e) {
            var elm = $(e.currentTarget);
            if (elm.parent().hasClass("left")) {
                slider.prev();
            }
            else {
                slider.next();
            }
        });
    });
    if ($("#single-map").length) {
        var mapNode = $("#single-map");
        var map = L.map('single-map');
        var hasLatLng = false;
        var lat = 50.838589;
        var lng = 4.417500;
        if (mapNode.data("lat") != "" && mapNode.data("lng") != "" && !isNaN(mapNode.data("lat")) && !isNaN(mapNode.data("lng"))) {
            lat = parseFloat(mapNode.data("lat"));
            lng = parseFloat(mapNode.data("lng"));
            hasLatLng = true;
        }
        map.setView([lat, lng], 12);
        map.scrollWheelZoom.disable();
        L.tileLayer.provider("CartoDB.Positron").addTo(map);
        map.touchZoom.disable();
        var icon = new L.Icon({
            iconUrl: '/app/themes/spruce/static/gfx/pointer.png',
            iconSize: [39, 59],
            iconAnchor: [18, 59],
            popupAnchor: [1, -59],
            shadowSize: [0, 0]
        });
        if (hasLatLng) {
            L
                .marker([lat, lng], { icon: icon })
                .addTo(map);
        }
    }
    // let options = options || {};
    $('body').ihavecookies(options);
    if ($.fn.ihavecookies.preference('analytics') === true) {
        activateTracking();
    }
    $('#ihavecookiesBtn').on('click', function (e) {
        e.preventDefault();
        $('body').ihavecookies(options, 'reinit');
    });
});
